//
//
//

const endDate = new Date()
const startDate = new Date()
export default {
  props:{
    title:{
      type:String,
      default:''
    },
    endMonth:{
      type:Number,
      default:0
    },
    startMonth:{
      type:Number,
      default:0
    },
    format:{
      type:String,
      default:'YYYY-MM-DD'
    },
    workTime:{
      type:Boolean,
      default:false
    }
  },
  computed:{
    hourList(){
      if(this.workTime) return ['09','10','11','12','13','14','15','16','17','18','19']
      else return ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','00']
    }
  },
  data(){
    return{
      date:''
    }
  },
  methods:{
    showTime(){
      let _this = this
      endDate.setMonth(endDate.getMonth() + this.endMonth)
      startDate.setMonth(startDate.getMonth() - this.startMonth)
      this.$vux.datetime.show({
        cancelText: '取消',
        confirmText: '确定',
        format: this.format,
        yearRow:"{value}年",
        monthRow:"{value}月",
        dayRow:"{value}日",
        hourRow:"{value}时",
        minuteRow:"{value}分",
        hourList:this.hourList,
        startDate:this.dateFormat(startDate,'yyyy-MM-dd'),
        endDate:this.dateFormat(endDate,'yyyy-MM-dd'),
        value: _this.date,
        onConfirm (value) {
          _this.date = value
        }
      })
    },
    dateFormat(str,fmt){
      let date = new Date(str)
      if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      let o = {
          'M+': date.getMonth() + 1,
          'd+': date.getDate(),
          'h+': date.getHours(),
          'm+': date.getMinutes(),
          's+': date.getSeconds()
      };
      for (let k in o) {
          if (new RegExp(`(${k})`).test(fmt)) {
              let str = o[k] + '';
              fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
          }
      }
      return fmt
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/datePicker/index.vue